import { useMemo } from 'react';
import { Price } from 'shared-types/Common';
import { TimeSlotType } from 'shared-types/SpaPackage';

import { calculateTotalPrice } from '../SpaDayBooking.helpers';
import { calculateExtraPrices } from '../../SpaPackageModal/SpaPackageModal.helpers';
import { ExtrasFormDataType } from '../../SpaPackageModal/SpaPackageModal.types';
import { SpaPackageFormValues } from '../../SpaPackageForm.schema';

type UseTotalPriceParams = {
  entityPrice: Price | undefined;
  selectedDateTimeSlots: TimeSlotType[] | undefined;
  selectedTime: string | undefined;
  watchedGuests: SpaPackageFormValues['guests'] | undefined;
  watchedExtras: SpaPackageFormValues['extras'] | undefined;
};

export function useTotalPrice({
  entityPrice,
  selectedDateTimeSlots,
  selectedTime,
  watchedGuests,
  watchedExtras,
}: UseTotalPriceParams) {
  const slotPrice = selectedDateTimeSlots?.find((slot) => slot.startTime === selectedTime)?.price;

  const guestsCount = watchedGuests?.length || 0;

  const extrasTotal = useMemo(
    () =>
      calculateExtraPrices(
        Object.fromEntries(
          Object.entries(watchedExtras || {}).filter(([, v]) => Array.isArray(v))
        ) as ExtrasFormDataType
      ),
    [watchedExtras]
  );

  const displayedPrice = slotPrice || entityPrice;
  const totalPrice = displayedPrice
    ? calculateTotalPrice(displayedPrice, guestsCount, extrasTotal)
    : null;

  return { totalPrice, guestsCount };
}
